import { useState } from 'react';
import moment from 'moment';
import { DatePicker, Form, Input } from 'antd';
import FormPage from '../../../../../components/pages/FormPage';

const DefModel = {
    isCreate: true,
    master_awb: '',
    house_awb: '',
    no_dok_inout: '',
    tgl_dok_inout: null,
};

export default () => {
    const [model, setModel] = useState(DefModel);

    const handleEditFormEvent = (values = {}) => {
        const isCreate = values?.isCreate ?? !values?._id;
        return {
            ...values,
            isCreate,
            tgl_dok_inout: values?.tgl_dok_inout
                ? moment(values.tgl_dok_inout, 'DD-MM-YYYY')
                : null,
        };
    };

    const handleSaveEvent = (values) => ({
        ...values,
        tgl_dok_inout: values?.tgl_dok_inout
            ? moment(values.tgl_dok_inout).format('DD-MM-YYYY')
            : '',
    });

    const formatAwbNumber = (value) => {
        let str = value;
        if (str.length > 4 && str.substring(3, 4) !== '-') {
            str = str.substring(0, 3) + '-' + str.substring(3);
        }
        return str;
    }

    return (
        <FormPage
            url={'api/v1/import_verify/save'}
            formValid={false}
            model={model}
            setModel={setModel}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
            title={"Import Doc Verify"}
            emptyModel={DefModel}
            callbackPath={"/import/import_verify"}
            onEditFormEvent={handleEditFormEvent}
            onSaveEvent={handleSaveEvent}
        >
            <Form.Item label="Master AWB" name={'master_awb'}
                rules={[
                    {
                        required: true,
                        pattern: /^\d{3}-\d+$/,
                        message: 'Nomor mawb harus dalam format 000-0000000',
                    },
                ]}
                getValueFromEvent={(event) => formatAwbNumber(event.target.value)}
            >
                <Input autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={'house_awb'}
                label="House AWB"
                rules={[{ required: true, message: 'House AWB wajib diisi' }]}
            >
                <Input autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={'no_dok_inout'}
                label="No Dok In/Out"
                rules={[{ required: true, message: 'No Dok In/Out wajib diisi' }]}
            >
                <Input autoComplete="off" />
            </Form.Item>
            <Form.Item
                name={'tgl_dok_inout'}
                label="Tgl Dok In/Out"
                rules={[{ required: true, message: 'Tanggal Dokumen wajib diisi' }]}
            >
                <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    placeholder=""
                />
            </Form.Item>
        </FormPage>
    );
};
